// extracted by mini-css-extract-plugin
export default {"section":"TestimonialBlock_section__NlBRP","inner":"TestimonialBlock_inner__rJzXf","heading":"TestimonialBlock_heading__WeviT","grid":"TestimonialBlock_grid__xnyPI"};